import React from "react";
import "./css/ContactUs.css";

export const ContactUs: React.FC = () => {
    return (
        <div className="contact-container">
            <section className="contact-section">
                <p>
                    Skitterbook is created and maintained by FAR Authoring.
                    For enquiries, feedback, or support, you can reach us at:
                </p>

                <p className="contact-email">
                    <a href="mailto:farauthoring@gmail.com">
                        farauthoring@gmail.com
                    </a>
                </p>

                <p className="contact-note">
                    We aim to respond to messages as promptly as possible.
                </p>
            </section>
        </div>
    );
};

export default ContactUs;
